// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","239":"dfdb0d71","455":"3bc369db","488":"7213179a"}[chunkId] + ".chunk.js";
};